import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

const PackAmounts = [1000, 2000, 5000, 10000, 25000, 50000];
class Topup extends React.Component {
    constructor(props) {
        super(props);
        this.PurchasePackage = this.PurchasePackage.bind(this);
        this.previousProgress = false;
    }
    async PurchasePackage(pid) {
        if (!this.previousProgress) {
            this.previousProgress = true;
            let json = {
                package: PackAmounts[pid - 1]
            };
            let res = await GetORPostAsync("topup.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
            if (res.status === "error") {
                toast(res.message);
                this.previousProgress = false;
                if (res.message === "Session Expired") {
                    this.props.history.push({
                        pathname: "/"
                    });
                }
                return;
            }
            toast.success(res.message);
        } else {
            toast("Previous purchase on progress");
        }

    }
    // async confirmPurchase(pid) {
    //     let json = {
    //         package: PackAmounts[pid - 1]
    //     };
    //     let res = await GetORPostAsync("topup.asp", "POST", JSON.stringify(json), localStorage.getItem("token"));
    //     if (res.status === "error") {
    //         toast(res.message);
    //         this.previousProgress = false;
    //         if (res.message === "Session Expired") {
    //             this.props.history.push({
    //                 pathname: "/"
    //             });
    //         }
    //         return;
    //     }
    //     toast(res.message);
    //     this.previousProgress = false;
    // }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
                {/* <ol className="breadcrumb">
                    <li className="breadcrumb-item"><label><i className="fe fe-home mr-2 fs-14"></i>Main</label></li>
                    <li className="breadcrumb-item active" aria-current="page"><label>Buy Package</label></li>
                </ol> */}
            </div>
        </div>
            <div className="row">
                <div className="card col-lg-3 col-md-12 border-top-color-2">
                    <div className="card-body">

                        <div className="card card-body bg-color-2  mb-2">
                            <h3 className='text-center'>Silver</h3>
                            <div className="media">
                                <div className="media-body">
                                    <h3 className="font-25 text-center" style={{ color: "white" }}>1,000</h3>
                                </div>
                            </div>
                        </div>
                        <ul className="list list-unstyled mt-2">
                            <li>ROI 0.3% * 700 days  or (upto double)</li>
                            
                            <li>ROI Payout Daily</li>
                        </ul>
                        <div onClick={e => this.PurchasePackage(1)} className="card card-body bg-color-2 mt-5 mb-2" style={{ color: "white" }}><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> TOPUP </label> </div>
                    </div>
                </div>
                <div className="card col-lg-3 col-md-12 border-top-color-1">
                    <div className="card-body">
                        <div className="card card-body bg-color-1  mb-2">
                            <h3 className='text-center'>Gold</h3>
                            <div className="media">
                                <div className="media-body">
                                    <h3 className="font-25 text-center" style={{ color: "white" }}>2,000</h3>
                                </div>
                            </div>
                        </div>
                        <ul className="list list-unstyled mt-2">
                            <li>ROI 0.3% * 700 days  or (upto double)</li>
                            
                            <li>ROI Payout Daily</li>
                        </ul>
                        <div onClick={e => this.PurchasePackage(2)} className="card card-body bg-color-1 mt-5 mb-2" style={{ color: "white" }}><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> TOPUP </label> </div>
                    </div>
                </div>
                
                <div className="card col-lg-3 col-md-12 border-top-color-2">
                    <div className="card-body">
                        <div className="card card-body bg-color-2  mb-2">
                            <h3 className='text-center'>Platinum</h3>
                            <div className="media">
                                <div className="media-body">
                                    <h3 className="font-25 text-center" style={{ color: "white" }}>5,000</h3>
                                </div>
                            </div>
                        </div>
                        <ul className="list list-unstyled mt-2">
                            <li>ROI 0.3% * 700 days  or (upto double)</li>
                            
                            <li>ROI Payout Daily</li>
                        </ul>
                        <div onClick={e => this.PurchasePackage(3)} className="card card-body bg-color-2 mt-5 mb-2" style={{ color: "white" }}><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> TOPUP </label> </div>
                    </div>
                </div>
                <div className="card col-lg-3 col-md-12 border-top-color-1">
                    <div className="card-body">
                        <div className="card card-body bg-color-1 mb-2">
                            <h3 className='text-center'>Diamond</h3>
                            <div className="media">
                                <div className="media-body">
                                    <h3 className="font-25 text-center">10,000</h3>
                                </div>
                            </div>
                        </div>
                        <ul className="list list-unstyled mt-2">
                            <li>ROI 0.3% * 700 days  or (upto double)</li>
                            
                            <li>ROI Payout Daily</li>
                        </ul>
                        <div onClick={e => this.PurchasePackage(4)} className="card card-body bg-color-1 mt-5 mb-2"><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> TOPUP </label> </div>
                    </div>

                </div>
                <div className="card col-lg-3 col-md-12 border-top-color-1">
                    <div className="card-body">
                        <div className="card card-body bg-color-1 mb-2">
                            <h3 className='text-center'>Double Diamond</h3>
                            <div className="media">
                                <div className="media-body">
                                    <h3 className="font-25 text-center">25,000</h3>
                                </div>
                            </div>
                        </div>
                        <ul className="list list-unstyled mt-2">
                            <li>ROI 0.3% * 700 days  or (upto double)</li>
                            
                            <li>ROI Payout Daily</li>
                        </ul>
                        <div onClick={e => this.PurchasePackage(5)} className="card card-body bg-color-1 mt-5 mb-2"><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> TOPUP </label> </div>
                    </div>

                </div>

                <div className="card col-lg-3 col-md-12 border-top-color-2">
                    <div className="card-body">
                        <div className="card card-body bg-color-2 mb-2">
                            <h3 className='text-center'>Triple Diamond</h3>
                            <div className="media">
                                <div className="media-body">
                                    <h3 className="font-25 text-center">50,000</h3>
                                </div>
                            </div>
                        </div>
                        <ul className="list list-unstyled mt-2">
                            <li>ROI 0.3% * 700 days  or (upto double)</li>
                            
                            <li>ROI Payout Daily</li>
                        </ul>
                        <div onClick={e => this.PurchasePackage(6)} className="card card-body bg-color-2 mt-5 mb-2"><label className="text-center fs-18"><i className="fe fe-shopping-cart mr-2 fs-20"></i> TOPUP </label> </div>
                    </div>

                </div>
            </div>
        </div>
        );
    }
}

export default  withRouter(Topup);